import { render } from "./LocalCreate.vue?vue&type=template&id=3c699020"
import script from "./LocalCreate.vue?vue&type=script&lang=js"
export * from "./LocalCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__